<template>
    <div>
        <video ref="videoRef" :autoplay="autoplay" width="620" controls type="video/mp4"></video>
    </div>
</template>

<script>
  export default {
    props: {
      blobVideo: Blob,
      autoplay: Boolean,
    },
    mounted() {
        this.$refs.videoRef.load()
        this.$refs.videoRef.src = this.blobVideo
        this.$refs.videoRef.play()
    },
    beforeDestroy() {
      // Libere a URL do Blob quando não for mais necessária
      URL.revokeObjectURL(this.$refs.videoRef.src);
    },
  }
</script>
  